<template>
	<div class="container">
		<!-- 头部定位与搜索 -->
		<div class="header">
			<div class="location">
				<span class="location-tou">
					<span class="location-icon">
						<img src="../../assets/位置.png" class="img" />
					</span>
					工作位置：{{JSON.stringify(sunlocationadd)==='{}'?'定位失败':`${ sunlocationadd.city}/ ${ sunlocationadd.district
}/${ sunlocationadd.formattedAddress}`}}
					<!-- 使用当前位置按钮 -->
					<el-button v-if="showUseCurrentLocation" size="mini" type="primary" @click="useCurrentLocation"
						class="use-current-btn">
						使用当前位置
					</el-button>
				</span>
				<div class="inp">
					<div class="inp-con">
						<!-- 地址输入框 -->
						<div class="address-input-wrapper">
							<el-input v-model="formattedAddress" size="medium" class="Cinput" placeholder="输入工作地址"
								@focus="showPoiDropdown = true" @input="handleAddressInput" @blur="handleInputBlur">
								<template #suffix>
									<span v-if="formattedAddress" class="clear-icon" @click.stop="SuseCurrentLocation">
										✖
									</span>
								</template>
							</el-input>
							<!-- POI下拉框 -->
							<div v-if="showPoiDropdown && poiList.length > 0" class="poi-dropdown">
								<div v-for="poi in poiList" :key="poi.id" class="poi-item" @mousedown="selectPoi(poi)">
									<div class="poi-name">{{ poi.name }}</div>
									<div class="poi-address">{{ poi.address }}</div>
									<div class="poi-distance">{{ (poi.distance / 1000).toFixed(1) }}km</div>
								</div>
							</div>
						</div>

						<!-- 工种输入框 -->
						<div class="worktype-input-wrapper">
							<el-input v-model="worktypeName" size="medium" class="Cinput" placeholder="请输入工种或服务内容"
								@focus="showWorktypeDropdown = true" @input="handleWorktypeInput"
								@blur="handleWorktypeBlur">
								<template #suffix>
									<span v-if="worktypeName" class="clear-icon" @click.stop="clearWorktype">
										✖
									</span>
								</template>
							</el-input>
							<!-- 工种下拉框 -->
							<div v-if="showWorktypeDropdown" class="worktype-dropdown">
								<!-- 右侧字母索引栏 -->
								<div class="index-bar" @mousedown.prevent>
									<div v-for="letter in availableLetters" :key="letter" class="index-letter"
										:class="{ active: currentLetter === letter }"
										@mousedown.prevent="handleLetterClick(letter)">
										{{ letter }}
									</div>
								</div>

								<!-- 主体内容 -->
								<div class="service-list" ref="serviceList" @scroll="onScroll">
									<div v-for="(services, letter) in filteredServices" :key="letter"
										:id="'letter-' + letter" class="group-section" :data-letter="letter">
										<div class="letter-title" :style="{ 
                      backgroundColor: colors[(letter.charCodeAt(0) - 64)%8],
                      position: currentLetter === letter ? 'sticky' : 'relative',
                      top: currentLetter === letter ? '0' : 'auto',
                      zIndex: currentLetter === letter ? 100 : 1
                    }">
											{{ letter }}
										</div>
										<div v-for="service in services" :key="service.id" class="service-text"
											@click="selectWorktype(service)">
											{{ service.name }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="inp-con1">
						<el-button :type="requestData.sort === '1' ? 'danger' : ''" :plain="requestData.sort !== '1'"
							@click="sortByDistance">
							按距离排序
						</el-button>
						<el-button :type="requestData.sort === '2' ? 'danger' : ''" :plain="requestData.sort !== '2'"
							@click="sortByScore">
							按评分排序
						</el-button>
					</div>
				</div>
			</div>
		</div>
		<el-divider />

		<!-- 工人列表 -->
		<div class="worker-list" ref="workerList" @scroll="handleScroll">
			<!-- 下拉刷新提示 -->
			<div v-if="refreshing" class="refresh-indicator">
				<div class="loading-spinner"></div>
				<span>刷新中...</span>
			</div>

			<div class="worker-grid">
				<div v-for="(item, index) in workers" :key="item.id || index" class="worker-card"
					@click="handleWorkerClick(item)">
					<div class="worker-info">
						<img :src="item.avatar || 'https://placehold.co/80x80'" class="avatar" alt="头像" />
						<div class="info">
							<span class="name">{{ item.name }}</span>
							<span class="skill">{{ getWorkerSkills(item) }}</span>
							<div class="status-line">
								<div class="status-info">
									<span class="status-badge" :class="item.workStatus === '1' ? 'online' : 'offline'">
										{{ item.workStatus === '1' ? '接单中' : '休息中' }}
									</span>
									<span class="score">评分: {{ item.score > 0 ? item.score.toFixed(1) : '暂无' }}</span>
								</div>
								<div class="contact-info">
									<span class="phone-icon">📞</span>
									<span class="phone-number">{{ item.phone || '暂无电话' }}</span>
								</div>
							</div>
						</div>
					</div>
					<div class="distance">{{ (item.dis / 1000).toFixed(1) }}km</div>
				</div>
			</div>

			<!-- 加载更多提示 -->
			<div v-if="loading" class="load-more">
				<div class="loading-spinner"></div>
				<span>加载中...</span>
			</div>
			<div v-else-if="hasMore" class="load-more">
				<span>上拉加载更多</span>
			</div>
			<div v-else class="load-more">
				<span>没有更多工人了</span>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		worker
	} from "../../utils/request.js"
	import {
		pinyin
	} from 'pinyin-pro';
	import {
		Getitem
	} from "@/utils/item.js";

	export default {
		data() {
			return {
				location: "定位中...",
				locationDetail: "",
				searchText: "",
				locationadd: {}, //当前定位信息
				sunlocationadd: {}, //搜索定位信息
				formattedAddress: '',
				worktypeName: '', // 工种名称（显示用）
				worktypeId: '', // 工种ID（查询用）
				workers: [],
				amapKey: "e2e653a580ac297a5714ae36ce70e4ea",
				requestData: {
					longitude: '',
					latitude: '',
					page: 1,
					limit: 21,
					workTypeServicesId: '',
					sort: "1" // 1=距离排序（默认），2=评分排序
				},
				loading: false,
				hasMore: true,
				refreshing: false,
				scrollTimeout: null,
				pullStartY: 0,
				pulling: false,
				// 新增POI相关数据
				showPoiDropdown: false,
				poiList: [],
				poiSearchTimer: null,
				// 新增工种选择相关数据
				showWorktypeDropdown: false,
				groupedServices: {},
				alphabet: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split(''),
				currentLetter: 'A',
				scrollTarget: '',
				colors: [],
				isManualScroll: false,
				lastScrollTime: 0,
				activeThreshold: 150,
				sectionPositions: [],
				originalServices: {},
				debounceTimer: null,
				isSearching: false,
				isUsingCurrentLocation: true, // 新增：标记是否使用当前位置
			};
		},
		computed: {
			availableLetters() {
				return this.alphabet.filter(letter =>
					this.filteredServices[letter] &&
					this.filteredServices[letter].length > 0
				);
			},
			filteredServices() {
				if (!this.worktypeName.trim()) {
					this.isSearching = false;
					return this.groupedServices;
				}

				const result = {};
				const keyword = this.worktypeName.toLowerCase();

				Object.keys(this.groupedServices).forEach(letter => {
					const filtered = this.groupedServices[letter].filter(service => {
						const serviceName = service.name;

						// 1. 直接匹配服务名称
						if (serviceName.toLowerCase().includes(keyword)) {
							return true;
						}

						// 2. 匹配拼音全拼
						const fullPinyin = pinyin(serviceName, {
							toneType: 'none'
						}).replace(/\s+/g, '');
						if (fullPinyin.includes(keyword)) {
							return true;
						}

						// 3. 匹配首字母
						const initials = pinyin(serviceName, {
							toneType: 'none',
							pattern: 'first',
							type: 'array'
						}).join('');

						if (initials.toLowerCase().includes(keyword)) {
							return true;
						}

						// 4. 混合匹配
						const mixed = serviceName.split('').map(char => {
							const charPinyin = pinyin(char, {
								toneType: 'none'
							});
							return charPinyin.length > 0 ? charPinyin[0].charAt(0) : char;
						}).join('');

						return mixed.toLowerCase().includes(keyword);
					});

					if (filtered.length > 0) {
						result[letter] = filtered;
					}
				});

				// 搜索时有结果，则跳转到第一个字母
				if (Object.keys(result).length > 0) {
					this.$nextTick(() => {
						const firstLetter = Object.keys(result).sort()[0];
						this.currentLetter = firstLetter;
						this.scrollTarget = `letter-${firstLetter}`;
						this.isSearching = true;
					});
				} else {
					this.isSearching = false;
				}

				return result;
			},
			// 新增：是否显示使用当前位置按钮
			showUseCurrentLocation() {
				if (!this.locationadd.lng || !this.sunlocationadd.lng) return false;
				return this.locationadd.lng !== this.sunlocationadd.lng ||
					this.locationadd.lat !== this.sunlocationadd.lat;
			}
		},
		watch: {
			worktypeName(newVal) {
				if (this.debounceTimer) clearTimeout(this.debounceTimer);
				this.debounceTimer = setTimeout(() => {
					this.isSearching = true;
					// 新增：当清空工种名称时，重新查询工人（无工种条件）
					if (!newVal.trim()) {
						this.worktypeId = '';
						this.requestData.workTypeServicesId = '';
						this.requestData.page = 1;
						this.workers = [];
						this.hasMore = true;
						this.sun_worker(true);
					}
				}, 300);
			}
		},
		async created() {
			this.getLocationByIP();
			this.initWorktypeData();
		},
		mounted() {
			// 添加触摸事件监听用于下拉刷新
			this.setupPullToRefresh();
		},
		beforeUnmount() {
			// 移除事件监听和清理定时器
			if (this.$refs.workerList) {
				this.$refs.workerList.removeEventListener('touchstart', this.handleTouchStart);
				this.$refs.workerList.removeEventListener('touchmove', this.handleTouchMove);
				this.$refs.workerList.removeEventListener('touchend', this.handleTouchEnd);
			}
			if (this.scrollTimeout) {
				clearTimeout(this.scrollTimeout);
			}
			if (this.poiSearchTimer) {
				clearTimeout(this.poiSearchTimer);
			}
			if (this.debounceTimer) {
				clearTimeout(this.debounceTimer);
			}
		},
		methods: {
			// 新增：清空工种输入框
			clearWorktype() {
				this.worktypeName = '';
				this.worktypeId = '';
				this.requestData.workTypeServicesId = '';
				this.requestData.page = 1;
				this.workers = [];
				this.hasMore = true;
				this.sun_worker(true);
				this.$message.success('已清空工种筛选');
			},


			// 新增：使用当前位置
			useCurrentLocation() {
				this.sunlocationadd = {
					...this.locationadd
				};
				this.formattedAddress = this.locationadd.formattedAddress || '';
				this.requestData.longitude = this.locationadd.lng;
				this.requestData.latitude = this.locationadd.lat;
				this.isUsingCurrentLocation = true;

				// 重新查询工人
				this.requestData.page = 1;
				this.workers = [];
				this.hasMore = true;
				this.sun_worker(true);

				this.$message.success('已切换到当前位置');
			},
			SuseCurrentLocation() {
				this.sunlocationadd = {
					...this.locationadd
				};
				this.formattedAddress = '';
				this.requestData.longitude = this.locationadd.lng;
				this.requestData.latitude = this.locationadd.lat;
				this.isUsingCurrentLocation = true;

				// 重新查询工人
				this.requestData.page = 1;
				this.workers = [];
				this.hasMore = true;
				this.sun_worker(true);


				this.$message.success('已切换到当前位置');
			},

			// 初始化工种数据
			initWorktypeData() {
				let s = Getitem('worktype');
				const allData = s.dataList
				console.log('全部工种：', allData);
				// 提取所有services并保留id和name
				const flatServices = allData.flatMap(category =>
					category.servicesList.map(service => ({
						id: service.id,
						name: service.services,
						category: category.name
					}))
				);
				console.log('变化后数据：', flatServices);

				this.originalServices = this.groupByPinyinInitial(flatServices);
				this.groupedServices = {
					...this.originalServices
				};
				this.currentLetter = Object.keys(this.groupedServices)[0] || 'A';
				this.colors = this.$store.state.Colors || [];
			},

			groupByPinyinInitial(services) {
				const grouped = {};

				services.forEach(service => {
					if (!service?.name) return;

					const initial = pinyin(service.name, {
						pattern: 'first',
						toneType: 'none',
						type: 'array'
					})[0]?.charAt(0).toUpperCase() || '#';

					if (!grouped[initial]) grouped[initial] = [];
					grouped[initial].push(service);
				});

				return Object.keys(grouped).sort().reduce((acc, letter) => {
					acc[letter] = grouped[letter];
					return acc;
				}, {});
			},

			// 工种输入处理
			handleWorktypeInput() {
				// 搜索逻辑已经在computed中处理
			},

			// 工种输入框失去焦点处理
			handleWorktypeBlur() {
				// 增加延迟时间，确保字母点击事件能先触发
				setTimeout(() => {
					this.showWorktypeDropdown = false;
				}, 300);
			},

			// 选择工种
			selectWorktype(service) {
				this.worktypeName = service.name;
				this.worktypeId = service.id;
				this.requestData.workTypeServicesId = service.id;
				this.showWorktypeDropdown = false;

				// 重新查询工人
				this.requestData.page = 1;
				this.workers = [];
				this.hasMore = true;
				this.sun_worker(true);

				this.$message.success(`已选择工种: ${service.name}`);
			},

			// 字母点击处理
			handleLetterClick(letter) {
				if (!this.filteredServices[letter]) return;

				this.isManualScroll = true;
				this.currentLetter = letter;
				this.scrollTarget = 'letter-' + letter;

				// 滚动到对应字母区域
				const element = document.getElementById('letter-' + letter);
				if (element && this.$refs.serviceList) {
					this.$refs.serviceList.scrollTop = element.offsetTop - this.$refs.serviceList.offsetTop;
				}

				setTimeout(() => {
					this.isManualScroll = false;
				}, 800);
			},

			// 滚动处理
			onScroll(e) {
				if (this.isSearching) {
					this.isSearching = false;
					return;
				}

				const now = Date.now();
				if (now - this.lastScrollTime < 50) return;
				this.lastScrollTime = now;

				if (this.isManualScroll) return;

				const scrollTop = this.$refs.serviceList ? this.$refs.serviceList.scrollTop : 0;
				const sections = this.$refs.serviceList ? this.$refs.serviceList.querySelectorAll('.group-section') : [];
				let activeLetter = '';

				for (let i = 0; i < sections.length; i++) {
					const section = sections[i];
					if (section.offsetTop - scrollTop <= this.activeThreshold) {
						activeLetter = section.dataset.letter;
					} else {
						if (i > 0) {
							activeLetter = sections[i - 1].dataset.letter;
						}
						break;
					}
				}

				if (activeLetter && this.currentLetter !== activeLetter) {
					this.currentLetter = activeLetter;
				}
			},

			// 地址输入处理
			handleAddressInput() {
				// 防抖处理，避免频繁请求
				if (this.poiSearchTimer) {
					clearTimeout(this.poiSearchTimer);
				}

				if (!this.formattedAddress.trim()) {
					this.poiList = [];
					return;
				}

				this.poiSearchTimer = setTimeout(() => {
					this.searchPoi(this.formattedAddress);
				}, 300);
			},

			// 输入框失去焦点处理
			handleInputBlur() {
				// 延迟隐藏下拉框，确保点击选项能触发
				setTimeout(() => {
					this.showPoiDropdown = false;
				}, 200);
			},

			// POI搜索
			async searchPoi(keyword) {
				if (!keyword.trim() || !this.locationadd.lng || !this.locationadd.lat) {
					this.poiList = [];
					return;
				}

				try {
					const response = await fetch(
						`https://restapi.amap.com/v3/assistant/inputtips?keywords=${encodeURIComponent(keyword)}&key=${this.amapKey}&location=${this.locationadd.lng},${this.locationadd.lat}&city=${this.locationadd.city || ''}`
					);

					if (!response.ok) throw new Error('POI搜索请求失败');

					const data = await response.json();
					console.log("POI搜索返回:", data);

					if (data.status === "1" && data.tips) {
						// 过滤并处理POI数据
						this.poiList = data.tips
							.filter(poi => poi.location && typeof poi.location === 'string') // 只保留有坐标且坐标是字符串的POI
							.map(poi => {
								try {
									const [lng, lat] = poi.location.split(',').map(Number);
									return {
										id: poi.id,
										name: poi.name,
										address: (poi.district || '') + (poi.address || ''),
										location: poi.location,
										distance: this.calculateDistance(
											this.locationadd.lng,
											this.locationadd.lat,
											lng,
											lat
										)
									};
								} catch (error) {
									console.error('解析POI坐标失败:', poi.location);
									return null;
								}
							})
							.filter(poi => poi !== null) // 过滤掉解析失败的POI
							.sort((a, b) => a.distance - b.distance); // 按距离排序
					} else {
						this.poiList = [];
					}
				} catch (error) {
					console.error("POI搜索失败:", error);
					this.poiList = [];
				}
			},

			// 计算两点间距离（米）
			calculateDistance(lng1, lat1, lng2, lat2) {
				const R = 6371000; // 地球半径（米）
				const dLat = (lat2 - lat1) * Math.PI / 180;
				const dLng = (lng2 - lng1) * Math.PI / 180;
				const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
					Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
					Math.sin(dLng / 2) * Math.sin(dLng / 2);
				const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
				return R * c;
			},

			async selectPoi(poi) {
				this.formattedAddress = poi.name;
				this.showPoiDropdown = false;
				this.isUsingCurrentLocation = false;

				// 解析坐标
				const [lng, lat] = poi.location.split(',').map(Number);

				try {
					// 使用逆地理编码获取POI的详细地址信息（包括城市和区域）
					const regeoResponse = await fetch(
						`https://restapi.amap.com/v3/geocode/regeo?location=${lng},${lat}&key=${this.amapKey}&radius=1000&extensions=base`
					);

					if (regeoResponse.ok) {
						const regeoData = await regeoResponse.json();
						if (regeoData.status === "1" && regeoData.regeocode) {
							const comp = regeoData.regeocode.addressComponent;

							// 更新sunlocationadd，包含完整的地址信息
							this.sunlocationadd = {
								city: comp.city || comp.province || this.sunlocationadd.city,
								district: comp.district || this.sunlocationadd.district,
								township: comp.township || '',
								formattedAddress: poi.name,
								lng: lng,
								lat: lat,
								address: poi.address
							};
						} else {
							// 如果逆地理编码失败，使用默认值
							this.sunlocationadd = {
								...this.sunlocationadd,
								formattedAddress: poi.name,
								lng: lng,
								lat: lat
							};
						}
					}
				} catch (error) {
					console.error("逆地理编码失败:", error);
					// 如果请求失败，至少更新坐标和名称
					this.sunlocationadd = {
						...this.sunlocationadd,
						formattedAddress: poi.name,
						lng: lng,
						lat: lat
					};
				}

				// 更新请求参数坐标
				this.requestData.longitude = lng;
				this.requestData.latitude = lat;

				// 重新查询工人
				this.requestData.page = 1;
				this.workers = [];
				this.hasMore = true;
				await this.sun_worker(true);

				this.$message.success(`已切换到位置: ${poi.name}`);
			},

			// 按距离排序
			sortByDistance() {
				if (this.requestData.sort === '1') return;
				this.requestData.sort = '1';
				this.requestData.page = 1;
				this.workers = [];
				this.hasMore = true;
				this.sun_worker(true);
				this.$message.success('已按距离排序');
			},

			// 按评分排序
			sortByScore() {
				if (this.requestData.sort === '2') return;
				this.requestData.sort = '2';
				this.requestData.page = 1;
				this.workers = [];
				this.hasMore = true;
				this.sun_worker(true);
				this.$message.success('已按评分排序');
			},

			// 简单的防抖函数
			debounce(func, wait) {
				return (...args) => {
					if (this.scrollTimeout) {
						clearTimeout(this.scrollTimeout);
					}
					this.scrollTimeout = setTimeout(() => {
						func.apply(this, args);
					}, wait);
				};
			},

			// 设置下拉刷新
			setupPullToRefresh() {
				const listElement = this.$refs.workerList;
				if (listElement) {
					listElement.addEventListener('touchstart', this.handleTouchStart);
					listElement.addEventListener('touchmove', this.handleTouchMove);
					listElement.addEventListener('touchend', this.handleTouchEnd);
				}
			},

			handleTouchStart(e) {
				if (this.$refs.workerList.scrollTop === 0) {
					this.pullStartY = e.touches[0].pageY;
					this.pulling = true;
				}
			},

			handleTouchMove(e) {
				if (!this.pulling) return;

				const pullDistance = e.touches[0].pageY - this.pullStartY;
				if (pullDistance > 0) {
					e.preventDefault();
				}
			},

			handleTouchEnd(e) {
				if (!this.pulling) return;

				const pullDistance = e.changedTouches[0].pageY - this.pullStartY;
				if (pullDistance > 100 && !this.refreshing) {
					this.handleRefresh();
				}
				this.pulling = false;
			},

			// 下拉刷新
			async handleRefresh() {
				this.refreshing = true;
				this.requestData.page = 1;
				await this.sun_worker(true);
				setTimeout(() => {
					this.refreshing = false;
				}, 1000);
			},

			// 滚动处理
			handleScroll(event) {
				this.debounce(this.checkScrollBottom, 200)();
			},

			// 检查是否滚动到底部
			checkScrollBottom() {
				const listElement = this.$refs.workerList;
				if (!listElement) return;

				const {
					scrollTop,
					scrollHeight,
					clientHeight
				} = listElement;
				if (scrollHeight - scrollTop - clientHeight < 50 && this.hasMore && !this.loading) {
					this.loadMore();
				}
			},

			// 加载更多
			async loadMore() {
				if (this.loading || !this.hasMore) return;
				this.requestData.page++;
				await this.sun_worker();
			},

			// 获取工人技能描述
			getWorkerSkills(worker) {
				if (worker.list && worker.list.length > 0) {
					const skills = worker.list.flatMap(item =>
						item.servicesList.map(service => service.workTypeServicesName)
					);
					return skills.join('、');
				}
				return '暂无技能信息';
			},

			// 工人卡片点击
			handleWorkerClick(worker) {
				console.log('工人详情:', worker);
				this.$message.info(`查看 ${worker.name} 的详情`);
			},

			async sun_worker(isRefresh = false) {
				if (this.loading) return;
				this.loading = true;

				try {
					let s = await worker(this.requestData)
					if (s.code === 200) {
						const newList = s.data.list || [];


						if (isRefresh || this.requestData.page === 1) {
							this.workers = newList;
						} else {
							this.workers = [...this.workers, ...newList];
						}

						this.hasMore = newList.length >= this.requestData.limit;
					} else {
						this.$message.error(s.msg || '获取工人列表失败');
						this.hasMore = false;
					}
				} catch (error) {
					console.error('获取工人列表错误:', error);
					this.$message.error('网络请求失败');
					this.hasMore = false;
				} finally {
					this.loading = false;
				}
			},

			// 去除地址中的省市县信息
			removeProvinceCityDistrict(formattedAddress, comp) {
				if (!formattedAddress) return '';

				let address = formattedAddress;

				if (comp.province && address.startsWith(comp.province)) {
					address = address.substring(comp.province.length);
				}

				if (comp.city && address.startsWith(comp.city)) {
					address = address.substring(comp.city.length);
				}

				if (comp.district && address.startsWith(comp.district)) {
					address = address.substring(comp.district.length);
				}

				address = address.replace(/^[\s、，,]+/, '');

				return address.trim() || formattedAddress;
			},

			// IP定位方法
			async getLocationByIP() {
				try {
					console.log("开始IP定位...");

					const response = await fetch(
						`https://restapi.amap.com/v3/ip?key=${this.amapKey}`
					);

					if (!response.ok) throw new Error(`IP定位请求失败：${response.status}`);

					const data = await response.json();
					console.log("IP定位返回:", data);

					if (data.status === "1" && data.city) {
						this.locationadd = {
							province: data.province,
							city: data.city,
							adcode: data.adcode,
							rectangle: data.rectangle,
						};
						this.sunlocationadd = this.locationadd

						await this.getPOIByRectangle(data.rectangle);

					} else {
						throw new Error("IP定位返回数据异常");
					}
				} catch (error) {
					console.error("IP定位失败:", error.message);
					await this.useDefaultCity();
				}
			},

			// 根据矩形区域获取中心点并进行逆地理编码
			async getPOIByRectangle(rectangle) {
				try {
					if (!rectangle) {
						throw new Error("无矩形区域信息");
					}

					const [bottomLeft, topRight] = rectangle.split(";");
					const [lng1, lat1] = bottomLeft.split(",").map(Number);
					const [lng2, lat2] = topRight.split(",").map(Number);

					const centerLng = (lng1 + lng2) / 2;
					const centerLat = (lat1 + lat2) / 2;

					console.log("矩形区域中心点:", centerLng, centerLat);

					await this.reverseGeocodeWithPOI(centerLng, centerLat);
				} catch (error) {
					console.error("解析矩形区域失败:", error);
					await this.geocodeByCityName(this.locationadd.city);
				}
			},

			// 逆地理编码获取POI信息
			async reverseGeocodeWithPOI(lng, lat) {
				try {
					const response = await fetch(
						`https://restapi.amap.com/v3/geocode/regeo?location=${lng},${lat}&key=${this.amapKey}&radius=1000&extensions=all&poitype=商务住宅|餐饮服务|购物服务|生活服务|体育休闲服务|医疗保健服务|住宿服务|风景名胜|政府机构及社会团体|交通设施服务|金融保险服务|公司企业|道路附属设施|地名地址信息|公共设施`
					);

					if (!response.ok)
						throw new Error(`逆地理编码请求失败：${response.status}`);

					const data = await response.json();
					console.log("逆地理编码返回POI信息:", data);

					if (data.status === "1" && data.regeocode) {
						const comp = data.regeocode.addressComponent;
						const formattedAddress = data.regeocode.formatted_address;
						const pois = data.regeocode.pois || [];

						const detailedAddress = this.removeProvinceCityDistrict(formattedAddress, comp);

						this.location = `${comp.city || comp.province || ""}`;

						if (pois.length > 0) {
							this.locationDetail = `附近：${pois[0].name}`;
						} else {
							this.locationDetail = detailedAddress;
						}

						this.locationadd = {
							city: comp.city || "",
							district: comp.district || "",
							township: comp.township || "",
							formattedAddress: detailedAddress,
							pois: pois.slice(0, 5),
							lng,
							lat
						};
						this.sunlocationadd = this.locationadd
						this.requestData.longitude = this.locationadd.lng
						this.requestData.latitude = this.locationadd.lat

						this.sun_worker(true)
					} else {
						throw new Error("逆地理编码数据异常");
					}
				} catch (error) {
					console.error("逆地理编码失败:", error.message);
					this.location = this.locationadd.city;
					this.locationDetail = "";
				}

			},

			// 通过城市名称进行地理编码（备用方案）
			async geocodeByCityName(cityName) {
				try {
					const response = await fetch(
						`https://restapi.amap.com/v3/geocode/geo?address=${encodeURIComponent(
            cityName
          )}&key=${this.amapKey}`
					);

					const data = await response.json();
					console.log("地理编码返回:", data);

					if (data.status === "1" && data.geocodes && data.geocodes.length > 0) {
						const location = data.geocodes[0].location;
						const [lng, lat] = location.split(",").map(Number);
						await this.reverseGeocodeWithPOI(lng, lat);
					} else {
						throw new Error("地理编码失败");
					}
				} catch (error) {
					console.error("地理编码失败:", error);
					this.location = cityName;
					this.locationDetail = "";
				}
			},

			// 备用方案：使用默认城市
			async useDefaultCity() {
				console.log("使用默认城市");
				this.location = "北京市";
				const defaultLng = 116.397428;
				const defaultLat = 39.90923;
				await this.reverseGeocodeWithPOI(defaultLng, defaultLat);
			},
		},
	};
</script>
<style scoped lang="scss">
	.container {
		height: 90vh;
		width: 100vw;
		background: #f8f8f8;
		font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
		box-shadow: 10px -5px 2px rgba(0, 0, 0, 0.2);
	}

	.nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 20rpx 40rpx;
		box-shadow: 0 2rpx 8rpx rgba(0, 0, 0, 0.08);

		.logo {
			font-size: 36rpx;
			font-weight: bold;
			color: #ff5a5f;
		}

		.nav-links {
			display: flex;
			gap: 40rpx;

			span {
				font-size: 28rpx;
				color: #333;
				cursor: pointer;
				transition: color 0.2s;
			}

			span:hover {
				color: #ff5a5f;
			}
		}
	}

	.header {
		height: 10vh;
		border-bottom: 1rpx solid #eee;
		display: flex;
		align-items: center;

		.location {
			display: flex;
			flex-direction: column;
			color: #555;
			font-size: 30rpx;
			font-weight: 900;
			margin-bottom: 30rpx;

			.location-detail {
				font-size: 24rpx;
				color: #888;
				margin-top: 5rpx;
			}

			.location-tou {
				height: 5vh;
				display: flex;
				justify-content: left;
				align-items: center;
				padding: 0 15px;
				position: relative;

				.location-icon {
					margin-right: 2px;
					font-size: 18px;

					.img {
						width: 20px;
						height: 20px;
					}
				}

				.use-current-btn {
					margin-left: 10px;
					font-size: 12px;
					height: 24px;
					padding: 0 8px;
				}
			}

			.inp {
				width: 100vw;
				height: 5vh;
				padding: 0 15px;
				display: flex;
				flex-wrap: nowrap;
				justify-content: left;
				align-items: center;
				gap: 15px;

				.inp-con {
					width: 60vw;
					height: 5vh;
					padding: 0 15px;
					display: flex;
					flex-wrap: nowrap;
					justify-content: left;
					align-items: center;
					gap: 25px;

					.Cinput {
						width: 250px;
					}
				}

				.inp-con1 {
					height: 5vh;
					padding: 0 15px;
					display: flex;
					flex-wrap: nowrap;
					justify-content: center;
					align-items: center;
					gap: 30px;
				}
			}
		}
	}

	// 新增：清空图标样式
	.clear-icon {
		cursor: pointer;
		color: #c0c4cc;
		font-size: 14px;
		padding: 0 4px;
		transition: color 0.2s;
		display: flex; // 新增
		align-items: center; // 新增
		justify-content: center; // 新增
		height: 100%; // 新增

		&:hover {
			color: #909399;
		}
	}

	// 新增POI下拉框样式
	.address-input-wrapper {
		position: relative;
	}

	.poi-dropdown {
		position: absolute;
		top: 100%;
		left: 0;
		right: 0;
		background: white;
		border: 1px solid #e4e7ed;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		max-height: 400px;
		overflow-y: auto;
		z-index: 2000;
		margin-top: 4px;
	}

	.poi-item {
		padding: 8px 12px;
		cursor: pointer;
		border-bottom: 1px solid #f0f0f0;
		transition: background-color 0.2s;

		&:last-child {
			border-bottom: none;
		}

		&:hover {
			background-color: #f5f7fa;
		}

		.poi-name {
			font-size: 14px;
			font-weight: 500;
			color: #333;
			margin-bottom: 2px;
			text-align: left;
		}

		.poi-address {
			font-size: 12px;
			color: #666;
			margin-bottom: 2px;
			text-align: left;
		}

		.poi-distance {
			font-size: 11px;
			color: #999;
			text-align: right;
		}
	}

	// 修改工种下拉框样式
	.worktype-input-wrapper {
		position: relative;
	}

	.worktype-dropdown {
		position: absolute;
		top: 100%;
		left: 0;
		right: 0;
		background: white;
		border: 1px solid #e4e7ed;
		border-radius: 4px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		max-height: 500px;
		overflow: hidden;
		z-index: 2000;
		margin-top: 4px;
		display: flex;
		flex-direction: column;

		.index-bar {
			position: absolute;
			right: 10px;
			top: 10px;
			bottom: 10px;
			z-index: 150;
			display: flex;
			flex-direction: column;
			align-items: center;
			width: 30px;
			background: rgba(255, 255, 255, 0.9);
			border-radius: 15px;
			padding: 5px 0;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

			// 新增：防止索引栏触发blur事件
			pointer-events: auto;
		}

		.index-letter {
			font-size: 12px;
			padding: 2px 0;
			color: #666;
			cursor: pointer;
			width: 100%;
			text-align: center;

			&.active {
				color: red;
				font-weight: bold;
			}
		}

		.service-list {
			flex: 1;
			height: 400px;
			overflow-y: auto;
			padding: 10px;
			position: relative;

			.group-section {
				margin-bottom: 20px;
			}

			.letter-title {
				font-size: 16px;
				font-weight: bold;
				color: white;
				background-color: #1890ff;
				padding: 8px 15px;
				border-radius: 4px;
				// margin-bottom: 10px;
				box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
			}

			.service-text {
				font-size: 14px;
				padding: 8px 0;
				color: #444;
				border-bottom: 1px solid #f0f0f0;
				margin-left: 15px;
				cursor: pointer;
				transition: background-color 0.2s;
				text-align: left;

				&:hover {
					background-color: #f5f7fa;
				}
			}
		}
	}

	.worker-list {
		height: calc(74vh - 2px);
		overflow-y: auto;
		padding: 0 20px;
		position: relative;

		.refresh-indicator {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 10px;
			color: #666;
			font-size: 14px;

			.loading-spinner {
				width: 16px;
				height: 16px;
				border: 2px solid #f3f3f3;
				border-top: 2px solid #666;
				border-radius: 50%;
				animation: spin 1s linear infinite;
				margin-right: 8px;
			}
		}

		.worker-grid {
			display: grid;
			grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
			gap: 16px;
			padding: 16px 0;

			@media (max-width: 768px) {
				grid-template-columns: 1fr;
			}

			@media (min-width: 769px) and (max-width: 1200px) {
				grid-template-columns: repeat(2, 1fr);
			}

			@media (min-width: 1201px) {
				grid-template-columns: repeat(3, 1fr);
			}
		}

		.worker-card {
			background: #fff;
			border-radius: 12px;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
			padding: 20px;
			display: flex;
			justify-content: space-between;
			align-items: flex-start;
			cursor: pointer;
			transition: all 0.3s ease;
			border: 1px solid #e8e8e8;

			&:hover {
				transform: translateY(-2px);
				box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
			}

			.worker-info {
				display: flex;
				align-items: flex-start;
				flex: 1;

				.avatar {
					width: 60px;
					height: 60px;
					border-radius: 50%;
					margin-right: 16px;
					object-fit: cover;
				}

				.info {
					flex: 1;

					.name {
						font-size: 18px;
						font-weight: bold;
						color: #333;
						display: block;
						margin-bottom: 8px;
						text-align: left;
					}

					.skill {
						max-height: 80px;
						font-size: 14px;
						color: #666;
						display: block;
						margin-bottom: 8px;
						line-height: 1.4;
						text-align: left;
					}

					.status-line {
						display: flex;
						justify-content: space-between;
						align-items: center;
						margin-top: 8px;

						.status-info {
							display: flex;
							align-items: center;
							gap: 12px;

							.status-badge {
								padding: 2px 8px;
								border-radius: 12px;
								font-size: 11px;
								font-weight: 500;

								&.online {
									background: #f0f9ff;
									color: #1890ff;
									border: 1px solid #1890ff;
								}

								&.offline {
									background: #f5f5f5;
									color: #999;
									border: 1px solid #d9d9d9;
								}
							}

							.score {
								font-size: 12px;
								color: #666;
							}
						}

						.contact-info {
							display: flex;
							align-items: center;
							gap: 4px;
							font-size: 12px;
							color: #555;

							.phone-icon {
								font-size: 12px;
							}

							.phone-number {
								white-space: nowrap;
							}
						}
					}
				}
			}

			.distance {
				font-size: 14px;
				color: #999;
				font-weight: 500;
				white-space: nowrap;
			}
		}

		.load-more {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 20px;
			color: #666;
			font-size: 14px;

			.loading-spinner {
				width: 16px;
				height: 16px;
				border: 2px solid #f3f3f3;
				border-top: 2px solid #666;
				border-radius: 50%;
				animation: spin 1s linear infinite;
				margin-right: 8px;
			}
		}
	}

	@keyframes spin {
		0% {
			transform: rotate(0deg);
		}

		100% {
			transform: rotate(360deg);
		}
	}
</style>